import { createStyles } from "@mantine/emotion";

export const useStylesUserInputBlock = createStyles((theme) => {
  return {
    userInputBlock: {
      "> div.mantine-Flex-root": {
        [`@media (max-width: ${theme.spacing.userInputBlock.breakpoint})`]: {
          justifyContent: "flex-start !important",
        },
      },
    },
    wrap: {
      "div button": {
        left: "auto",
      },
    },
  };
});
